import React from "react";
import { useAppText } from "src/commun/composants/AppText";
import { useFormikContext } from "formik";
import AppRow from "src/commun/composants/grille/AppRow";
import AppCol from "src/commun/composants/grille/AppCol";
import AppCheckboxFormik from "src/commun/composants/formulaire/formik/fields/AppCheckboxFormik";
import { AcceptCGU } from "src/pages/validationCGU/form/useValidationSchemaValidationCGU";
import styles from "src/pages/validationCGU/ValidationCGU.scss";
import { useAppState } from "src/app/state/StateProvider";


const ValidationCGUFormContent = () => {

  const [{ cguLink }] = useAppState();
  const { tString } = useAppText();
  const { submitForm } = useFormikContext<AcceptCGU>();

  return (
    <AppRow>
      <AppCol >
        <label className={styles.titre}>{tString("cgu.titre")}</label>

        <div className="mt-10 paragraph--gray">
          <label>{tString("cgu.legend")}</label>
        </div>

        <div className="mt-10 paragraph--gray">
          <AppCheckboxFormik name="acceptCGU" value={"false"} label={<label>{tString("cgu.accepte.lu")}<a className="appLink" href={cguLink} target="_blank" rel="noopener noreferrer">{tString("cgu.accepte.lu.lien")}</a></label>} />
        </div>
        <input
          className="btn__primary mt-10  btn--full--xs"
          type="submit"
          name="submit"
          onClick={submitForm}
          value={tString("action.envoyer")}
        />

      </AppCol>
    </AppRow>
  );
};

export default ValidationCGUFormContent;